import React from "react";
import Slider from "./Slider/Slider";
import Nevigation from "./Nevigation/Nevigation";
import TopBanner from "./TopBanner/TopBanner";

const Header = () => {
  return (
    <div>
      <Nevigation/>
       
       <Slider/>
      {/* <TopBanner/> */}
      {/* <Nevigation/> */}
      
      
    </div>
  );
};

export default Header;
